export default __webpack_public_path__ + "static/media/InstagramMock.df8a2744.png";